import Brace from "backbone.brace";

const Model = Brace.Model.extend({
  namedAttributes: {
    memberNumber: String,
    memberName: String,
    memberDob: Date,
    eligIssuersOnDos: String,
    providerNbr: String,
    providerName: String,
    providerEin: String,
    providerNpid: String,
    fromDos: Date,
    throughDos: Date,
    diagnosisCode: String,
    categoryWeight: Number,
    hccCode: String,
    hccDescription: String,
    groupCode: String,
    groupDescription: String,
    cmRunSid: Number,
    cmRunDate: Date,
    paramSetSid: Number,
    paramTypeSetSid: Number,
    deleteRunSid: Number,
  },
  defaults: {
    memberNumber: null,
    memberName: null,
    memberDob: null,
    eligIssuersOnDos: null,
    providerNbr: null,
    providerName: null,
    providerEin: null,
    providerNpid: null,
    fromDos: null,
    throughDos: null,
    diagnosisCode: null,
    categoryWeight: null,
    hccCode: null,
    hccDescription: null,
    groupCode: null,
    groupDescription: null,
    cmRunSid: null,
    cmRunDate: null,
    paramSetSid: null,
    paramTypeSetSid: null,
    deleteRunSid: null,
  },
});

export { Model as default };
